import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react';
import _ from 'lodash';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import { useFormState } from 'react-final-form';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';
import {
  TIPO_CONTA_FATURA_LIST,
} from './tipoContaUtils';

export default function QCXSelectTipoContaFaturaAutocomplete({
  label,
  name,
  disabled,
  ...restProps
}) {
  const { values } = useFormState();

  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    const value = TIPO_CONTA_FATURA_LIST
      .find((item) => (
        item?.value === _.get(values, name)
      ));

    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue('');
    }
  }, [values]);

  const filterOptions = useMemo(() => (
    createFilterOptions({
      stringify: (option) => (
        option.label + option.value
      ),
    })
  ), []);

  const getOptionLabel = useCallback((item) => (
    item?.label || ''
  ), []);

  const getOptionValue = useCallback((item) => (
    item?.value || ''
  ), []);

  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={TIPO_CONTA_FATURA_LIST}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      disabled={disabled}
      {...restProps}
    />
  );
}
